import React from 'react';

import { Audit } from 'models/Audit';
import Table from 'components/Table';
import {
  CircularProgress,
  makeStyles,
  TableCell,
  TableRow
} from '@material-ui/core';
import { JobMovementEngineerInfo } from 'models/Engineers';
import { auditEntriesToRows } from './auditHelper';

interface HistoryPaneProps {
  auditData: Audit[];
  engineers?: JobMovementEngineerInfo[];
  isLoading: boolean;
  columnWidths?: number[];
  className?: string;
}

const useStyles = makeStyles(theme => ({
  actionCell: {
    textTransform: 'none'
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(5)
  }
}));

const columnHeaders = ['Date', 'Action', 'Actioned by'];
const defaultColumnWidths = [160, 320, 160];

export function HistoryPane({
  auditData,
  engineers,
  isLoading,
  columnWidths = defaultColumnWidths,
  className
}: HistoryPaneProps) {
  const { actionCell, loadingWrapper } = useStyles();

  if (isLoading) {
    return (
      <div className={loadingWrapper}>
        <CircularProgress size={48} data-testid="auditHistorySpinner" />
      </div>
    );
  }

  const rows = auditEntriesToRows(auditData, engineers).map(
    ({ time, action, actionedBy }) => (
      <TableRow key={action + time}>
        <TableCell>{time}</TableCell>
        <TableCell className={actionCell}>{action}</TableCell>
        <TableCell>{actionedBy}</TableCell>
      </TableRow>
    )
  );

  return (
    <div className={className}>
      <Table
        columnHeaders={columnHeaders}
        columnWidths={columnWidths}
        rows={rows}
      />
    </div>
  );
}
